import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import auth from '@/utils/directives';
import { ERROR_ICON, IMG_URL } from './utils/utils';

Vue.use(ElementUI);
Vue.directive('auth', auth);

Vue.filter('filter_img',(src='')=>{
  if(!src){
    return ERROR_ICON;
  }
  if(src.includes('http')){
    return src;
  }else{
    return IMG_URL + src;
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
